import { PencilLine, Plus, Trash2 } from "lucide-react";

import { AuditActionType } from "@/api/admin/auditLog";

export const IconMap = {
  [AuditActionType.CREATE]: <Plus className="h-4 w-4 text-white" />,
  [AuditActionType.UPDATE]: <PencilLine className="h-4 w-4 text-white" />,
  [AuditActionType.DELETE]: <Trash2 className="h-4 w-4 text-white" />,
};

export const NodeColorMap = {
  [AuditActionType.CREATE]: "bg-green-600",
  [AuditActionType.UPDATE]: "bg-orange-500",
  [AuditActionType.DELETE]: "bg-red-600",
};

export const BageColorMap = {
  [AuditActionType.CREATE]:
    "bg-green-500/20 border border-green-600/10 text-green-800",
  [AuditActionType.UPDATE]:
    "bg-orange-400/20 border border-orange-600/10 text-orange-600",
  [AuditActionType.DELETE]:
    "bg-red-600/20  border border-red-600/10 text-red-800",
};
